<template>
  <div class="edu_pages">
    <div class="edu_pages_box">
      <div
        :class="
          eduInfo.eduBuresuType != -1 ? 'edu_info_box' : 'edu_info_box_two'
        "
      >
        <div class="title_box">
          <div class="title_icon"></div>
          <div class="title_text">基本信息</div>
        </div>
        <el-tooltip
          content="点击编辑"
          placement="top"
          effect="light"
          :disabled="!isEditInfo ? false : true"
        >
          <div
            :class="
              !isEditInfo ? 'info_content_box_one' : 'info_content_box_two'
            "
            @click="editClick"
          >
            <div
              class="info_item"
              v-for="(item, index) in baseInfoList"
              :key="index"
            >
              <div class="info_item_title">{{ item.title }}</div>
              <div class="info_item_content" v-if="!isEditInfo">
                {{ dataInfo[item.id] }}
              </div>
              <el-input
                class="info_item_input input-button"
                v-else
                v-model.trim="dataInfo[item.id]"
                :placeholder="'请输入' + item.title"
                size="small"
                clearable
              ></el-input>
              <div class="info_item_hr"></div>
            </div>
            <div class="info_item">
              <div class="info_item_title">LOGO:</div>
              <div class="info_item_logo" v-if="isEditInfo">
                <head-portrait-up-load
                  :imageUrl="dataInfo.logoImg"
                  @imageChange="imageChange"
                ></head-portrait-up-load>
              </div>
              <div
                class="info_item_content"
                v-else-if="!isEditInfo && !dataInfo.logoImg"
              >
                暂无图片
              </div>
              <div class="info_item_content_img" v-else>
                <el-image
                  style="width:78px;height:78px"
                  :src="$store.state.config.fileUrl + dataInfo.logoImg"
                >
                </el-image>
              </div>
              <div class="info_item_hr"></div>
            </div>
          </div>
        </el-tooltip>
        <div class="save_and_cencel_box" v-if="isEditInfo">
          <div class="btn_item" @click="sendEduData">提交</div>
          <div class="btn_item" @click="cencelClick">取消</div>
        </div>
      </div>
      <div class="edu_tabs_box" v-if="eduInfo.eduBuresuType != -1">
        <div class="edu_tabs_title_box">
          <div
            v-for="(item, index) in tabsData"
            :key="index"
            :class="
              tabsName == item.name
                ? 'pitch_edu_tabs_title_item_box'
                : 'un_pitch_edu_tabs_title_item_box'
            "
            @click="selectInfo(item)"
          >
              {{ item.title }}
            <div v-if="tabsName == item.name" class="pitch_underline"></div>
          </div>
        </div>
        <div class="cut_off_rule"></div>
        <div class="edu_tabs_content_box">
          <div class="platform_info_box" v-if="tabsName == tabsData[0].name">
              <div class="lng_adn_lat_box">
                <div class="platform_lng_box">
                  <span>经度:{{ positionInfo.lng }}</span>
                </div>
                <div class="platform_lat_box">
                  <span>纬度:{{ positionInfo.lat }}</span>
                </div>
              </div>
              <div class="map_platform_box">
                <baidu-map
                  ref="map"
                  v-if="center.lng != 0"
                  class="map"
                  :center="center"
                  :zoom="15"
                  :scroll-wheel-zoom="true"
                  :double-click-zoom="false"
                  :mapClick="false"
                >
                  <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
                  <bm-marker
                    :position="positionInfo"
                    :dragging="false"
                    animation="BMAP_ANIMATION_BOUNCE"
                    :icon="{
                      url: require('@/assets/img/edu/marker_sprite.png'),
                      size: { width: 20, height: 40 }
                    }"
                  >
                  </bm-marker>
                </baidu-map>
              </div>
            </div>
            <div class="picture_info_box" v-if="tabsName == tabsData[1].name">
              <el-upload
                class="upload-demo"
                action=""
                :show-file-list="false"
                accept="image/jpg, image/gif,image/png, image/jpeg"
                :http-request="upload"
              >
                <el-image
                  v-if="architectureDiagram.imgUrl"
                  class="picture_img_box"
                  :src="
                    $store.state.config.fileUrl + architectureDiagram.imgUrl
                  "
                >
                </el-image>
                <el-button
                  size="small"
                  type="primary"
                  class="el-icon-plus"
                  v-else
                  >点击上传</el-button
                >
              </el-upload>
            </div>
            <div class="framework_table_box" v-if="tabsName == tabsData[2].name">
              <el-table :data="organizationalStructure" height="100%" border>
                <el-table-column
                  label="序号"
                  width="70"
                  align="center"
                  type="index"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="position"
                  label="职务"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <el-input
                      v-if="scope.row.isEdit"
                      style="width:95%"
                      v-model.trim="scope.row.position"
                      placeholder="请输入职务"
                      size="mini"
                      clearable
                    ></el-input>
                    <span v-else>{{ scope.row.position }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="name"
                  label="姓名"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <el-input
                      v-if="scope.row.isEdit"
                      style="width:95%"
                      v-model.trim="scope.row.name"
                      placeholder="请输入姓名"
                      size="mini"
                      clearable
                    ></el-input>
                    <span v-else>{{ scope.row.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="phone"
                  label="手机号码"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <el-input
                      v-if="scope.row.isEdit"
                      style="width:95%"
                      v-model.trim="scope.row.phone"
                      placeholder="请输入手机号码"
                      size="mini"
                      clearable
                    ></el-input>
                    <span v-else>{{ scope.row.phone }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="telephone"
                  label="固定电话"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <el-input
                      v-if="scope.row.isEdit"
                      style="width:95%"
                      v-model.trim="scope.row.telephone"
                      placeholder="请输入固定电话"
                      size="mini"
                      clearable
                    ></el-input>
                    <span v-else>{{ scope.row.telephone }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="remark"
                  label="备注"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <el-input
                      v-if="scope.row.isEdit"
                      style="width:95%"
                      v-model.trim="scope.row.remark"
                      placeholder="请输入备注"
                      size="mini"
                      clearable
                    ></el-input>
                    <span v-else>{{ scope.row.remark }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                  <template slot-scope="scope">
                    <el-button
                      plain
                      v-if="!scope.row.isEdit"
                      type="warning"
                      size="mini"
                      icon="el-icon-open"
                      @click="editRow(scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      plain
                      v-if="scope.row.isEdit"
                      type="primary"
                      size="mini"
                      icon="el-icon-open"
                      @click="editOrganizationFramework(scope.row)"
                      >提交</el-button
                    >
                    <el-button
                      plain
                      v-if="scope.row.isEdit"
                      type="info"
                      size="mini"
                      icon="el-icon-open"
                      @click="centerEdit"
                      >取消</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadPortraitUpLoad from "@/components/HeadPortraitUpLoad";
export default {
  name: "",
  components: {
    HeadPortraitUpLoad
  },
  props: {},
  data() {
    return {
      // 通讯录信息
      workFileData: [],

      // 基础信息
      dataInfo: this.$store.getters.getEduData,
      // 资质证书列表
      certificateList: [],
      // 当前操作的证书
      thisCertificateInfo: {
        certificateImgUrl: ""
      },
      // 学校组织架构图
      architectureDiagram: {
        id: "",
        imgUrl: ""
      },
      // 组织架构
      organizationalStructure: [],

      // 当前操作的通讯录
      thiMailList: {
        fileName: "",
        fileSize: 0
      },
      // 百度地图
      center: {
        lng: 0,
        lat: 0
      },
      positionInfo: {},
      baseInfoList: [
        { title: "机构名称:", id: "eduBuresuName" },
        { title: "机构代码:", id: "organizationCode" },
        { title: "负责人:", id: "director" },
        { title: "安全责任人:", id: "safetyManager" },
        { title: "联系方式:", id: "phone" },
        { title: "职工数量:", id: "workersAmount" },
        { title: "通讯地址:", id: "contactAddress" }
      ],
      isEditInfo: false,
      tabsData: [
        { title: "地理位置", index: 1, name: "platform_info" },
        { title: "组织图", index: 2, name: "picture_info" },
        { title: "管理架构", index: 3, name: "framework_info" }
      ],
      tabsName: "platform_info"
    };
  },
  watch: {},
  computed: {
    eduInfo() {
      return JSON.parse(sessionStorage.getItem("eduInfo"));
    }
  },
  methods: {
    selectInfo(es) {
      this.tabsName = es.name;
      if (es.name == "platform_info") {
        // 地理位置
        this.getPositionInfo();
      } else if (es.name == "picture_info") {
        // 组织图
        this.getOrganizationFrameworkPicture();
      } else {
        this.getEduStructure();
      }
    },
    getPositionInfo() {
      var latAndLnt = this.dataInfo.eduCoordinate.split(",");
      this.center.lat = latAndLnt[1];
      this.center.lng = latAndLnt[0];
      this.positionInfo = this.center;
    },
    sel({ type, target, point, pixel, overlay }) {
      this.$confirm("您选择地理位置已改变,是否进行提交？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success"
      })
        .then(() => {
          this.positionInfo = point;
          this.dataInfo.eduCoordinate = point.lng + "," + point.lat;
          this.sendEduData();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消提交"
          });
        });
      // console.log(this.dataInfo.eduCoordinate)
    },

    // 发送教育局数据  编辑
    async sendEduData() {
      var requestData = {
        eduId: this.dataInfo.eduId,
        eduBuresuName: this.dataInfo.eduBuresuName,
        director: this.dataInfo.director,
        workersAmount: this.dataInfo.workersAmount,
        contactAddress: this.dataInfo.contactAddress,
        organizationCode: this.dataInfo.organizationCode,
        safetyManager: this.dataInfo.safetyManager,
        phone: this.dataInfo.phone,
        status: 0,
        eduCoordinate: this.dataInfo.eduCoordinate,
        parEduId: this.dataInfo.parEduId,
        regionCode: this.dataInfo.regionCode,
        logoImg: this.dataInfo.logoImg
      };
      // console.log(requestData)
      let res = await this.$Http.sendEduData(requestData, true);
      if (res.code == 200) {
        this.getDataInfo();
        this.$message({
          message: res.messsage,
          type: "success"
        });
        this.isEditInfo = false;
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    // 组织架构
    async getEduStructure() {
      var requestData = {
        eduId: this.dataInfo.eduId
      };
      let res = await this.$Http.getEduStructure(requestData);
      if (res.code == 200) {
        let data = res.data || [];
        this.organizationalStructure = data.map((item) => {
          item.isEdit = false;
          return item;
        });
      } else if (res.code == 101) {
        this.organizationalStructure = [];
      } else {
        this.organizationalStructure = [];
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    // 获取机构信息
    async getDataInfo() {
      var requestData = {
        eduId: this.dataInfo.eduId
      };
      let res = await this.$Http.getEduInfo(requestData);
      if (res.code == 200) {
        var eduInfo = res.data;
        sessionStorage.setItem("eduInfo", JSON.stringify(eduInfo));
        this.dataInfo = eduInfo;

        this.getPositionInfo();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    async upload(event) {
      // console.log(event)
      // return
      if (!this.architectureDiagram.id) {
        delete this.architectureDiagram.id;
      }
      let res = await this.$Common.fileUploadNew(event);
      this.architectureDiagram.imgUrl = res.fileUrl;
      this.setOrganizationFrameworkPicture();
    },
    // 图片上传成功
    handleAvatarSuccess(res, file) {
      if (!this.architectureDiagram.id) {
        delete this.architectureDiagram.id;
      }
      this.architectureDiagram.imgUrl = Object.values(res.data)[0];
      this.setOrganizationFrameworkPicture();
    },
    editRow(row) {
      row.isEdit = true;
    },
    centerEdit() {
      this.getEduStructure();
    },
    // 修改组织架构信息
    async editOrganizationFramework(info) {
      var requestData = [];
      requestData.push(info);
      let res = await this.$Http.editOrganizationFramework(requestData);
      if (res.code == 200) {
        info.isEdit = false;
        this.$message({
          message: res.messsage,
          type: "success"
        });
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    // 获取学校组织架构图
    async getOrganizationFrameworkPicture() {
      var requestData = {
        eduId: this.dataInfo.eduId
      };
      let res = await this.$Http.getOrganizationFrameworkPicture(
        requestData,
        true
      );
      if (res.code == 200) {
        this.architectureDiagram.id = res.data.id;
        this.architectureDiagram.imgUrl = res.data.imgUrl;
      } else if (res.code == 101) {
      } else {
        // console.log(res.messsage)
        // this.$message({
        //     message: res.messsage,
        //     type: 'error'
        // });
      }
    },

    // 更改组织架构图
    async setOrganizationFrameworkPicture() {
      var requestData = this.architectureDiagram;
      let res = await this.$Http.setOrganizationFrameworkPicture(
        requestData,
        true
      );
      // console.log(res)
      if (res.code == 200) {
        this.getOrganizationFrameworkPicture();
        this.$message({
          message: res.messsage,
          type: "success"
        });
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    // 基本信息切换为编辑状态
    editClick() {
      this.isEditInfo = true;
    },
    // 基本信息编辑取消
    cencelClick() {
      this.getDataInfo();
      this.isEditInfo = false;
    },
    // 基本信息LOGO选择
    imageChange(src) {
      this.dataInfo.logoImg = src || "";
    }
  },
  created() {},
  mounted() {
    this.getDataInfo();
  }
};
</script>
<style lang="scss" scoped>
@import "/css/base.css";
@import "/css/update_school_data.css";
.edu_pages{

.map {
  width: 100%;
  height: 100%;
}
.edu_pages_box {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
}
.edu_info_box {
  width: calc(25% - 5px);
  height: calc(100% - 5px);
  background: #fff;
  margin-right: 5px;
  padding: 10px 20px;
  // border: 1px solid #dcdfe6;
}
.edu_info_box_two {
  width: calc(100% - 5px);
  height: calc(100% - 5px);
  background: #fff;
  margin-right: 5px;
  padding: 10px 20px;
}
.edu_tabs_box {
  width: 75%;
  margin-bottom: 5px;
  height: calc(100% - 5px);
  background-color: #fff;
  position: relative;
  /deep/.el-tabs--border-card {
    color: red;
    height: 100%;
    .el-tabs__content {
      height: calc(100% - 40px);
      .el-tab-pane {
        height: 100%;
      }
    }
  }
}
.title_box {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  height: 30px;
  width: 120px;
  background: url("~@/assets/img/edu/edu_info_title_bg.png") center center
    no-repeat;
  background-size: 100% 100%;
  padding: 2px 10px;
  .title_icon {
    width: 26px;
    height: 26px;
    background: url("~@/assets/img/edu/base_info_icon.png") center center
      no-repeat;
    background-size: 100% 100%;
  }
  .title_text {
    margin-left: 10px;
    font-size: 14px;
    font-weight: bolder;
    color: rgba(71, 72, 89, 1);
  }
}
.info_content_box_one {
  width: 100%;
  margin: 10px 0px;
  height: calc(100% - 46px);
  overflow-y: scroll;
  cursor: pointer;
  scrollbar-width: none;
}
.info_content_box_two {
  width: 100%;
  margin: 10px 0px;
  height: calc(100% - 107px); //提交按钮60
  overflow-y: scroll;
  cursor: pointer;
}
.info_item {
  margin-top: 20px;
  .info_item_title {
    margin-left: 5px;
    font-size: 14px;
    color: #a5a5be;
    font-weight: 500;
  }
  .info_item_content {
    font-size: 15px;
    color: #474859;
    font-weight: 600;
    text-align: center;
    height: 36px;
    line-height: 36px;
  }
  .info_item_content_img {
    height: 78px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .info_item_logo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 78px;
    width: 100%;
  }
  .info_item_input {
    height: 36px;
    width: 100%;
  }
  .info_item_hr {
    width: 100%;
    height: 0.5px;
    margin: 2px 0px;
    background-color: #f1f0f0;
  }
}
.save_and_cencel_box {
  height: 60px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .btn_item {
    width: 90px;
    height: 30px;
    background: #179aff;
    box-shadow: 0px -2px 0px 0px #cde9ff;
    border-radius: 24px 6px 24px 6px;
    // border: 1px solid ##3eabff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-family: AlibabaPuHuiTiM;
    color: #ffffff;
    cursor: pointer;
    &:hover {
      background: #3eabff;
    }
  }
}
.input-button ::v-deep {
  .el-input__inner {
    border: 0;
    border-radius: 0px;
    &:focus {
      border-bottom: 1px solid #409eff;
    }
  }
}
.platform_info_box {
  padding: 5px;
  width: 100%;
  height: 100%;
  .lng_adn_lat_box {
    width: 100%;
    height: 50px;
    background: #cbe9ff;
    border-radius: 8px 8px 0px 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #474859;
    font-size: 15px;
    .platform_lng_box {
      margin-left: 5%;
      width: 12%;
      display: flex;
      justify-content: flex-start;
    }
    .platform_lat_box {
      width: 12%;
      display: flex;
      justify-content: flex-start;
    }
  }
  .map_platform_box {
    margin: 6px 0px;
    height: calc(100% - 56px);
    width: 100%;
  }
}
.framework_table_box {
  width: 100%;
  height: 100%;
  padding: 5px;
}
.picture_info_box {
  width: 100%;
  height: 100%;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  .upload-box {
    width: 100%;
    height: 100%;
    .picture_img_box {
      width: 100%;
      height: 100%;
    }
  }
}
.edu_tabs_title_box {
  width: calc(100% - 60px);
  height: 60px;
  margin: 0px 30px;
  padding-left: 20px;
  display: flex;
  align-items: center;
  flex-direction: row;
  // 选中
  .pitch_edu_tabs_title_item_box {
    width: 100px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    font-family: AlibabaPuHuiTiB;
    color: #474859;
    font-weight: 600;
  }
    // 选中下划线
    .pitch_underline {
      width: 70px;
      height: 4px;
      background: #3eabff;
      border-radius: 4px;
    }
  // 未选中
  .un_pitch_edu_tabs_title_item_box {
    width: 100px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-family: AlibabaPuHuiTiB;
    color: #6b6c7d;
    font-weight: 500;
  }
}
  .cut_off_rule {
    width: calc(100% - 60px);
  margin: 4px 30px;
    height: 2px;
    background: #f3f3f3;
  }
  .edu_tabs_content_box{
    margin: 0px 30px;
    width: calc(100% - 60px);
    height: calc(100% - 70px);
  }
}

</style>
